// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const AdminLoginPanel = () => {
//   const [credentials, setCredentials] = useState({
//     username: '',
//     password: ''
//   });
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     // Czyść błąd przy zmianie danych
//     if (error) setError('');
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError('');

//     // Symulacja procesu logowania (w rzeczywistości połączenie z API)
//     try {
//       // Tutaj w rzeczywistej aplikacji byłoby połączenie z backendem
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       // Przykładowe dane logowania (w rzeczywistości powinny być weryfikowane przez backend)
//       if (credentials.username === 'admin' && credentials.password === 'Przemek2115') {
//         // Zapisanie stanu zalogowania (w rzeczywistości token JWT)
//         localStorage.setItem('adminAuthenticated', 'true');
//         navigate('/admin/AdminPanelWithStyles');
//       } else {
//         setError('Nieprawidłowa nazwa użytkownika lub hasło');
//       }
//     } catch (err) {
//       setError('Wystąpił błąd podczas logowania');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#edece8] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
//         <div className="px-8 py-10">
//           <div className="text-center mb-8">
//             <img 
//               src="images/LOGO.jpg" 
//               alt="Kolorowe Domki" 
//               className="h-24 w-auto mx-auto mb-6"
//             />
//             <h2 className="text-3xl font-bold text-gray-800 mb-2">
//               Panel Administracyjny
//             </h2>
//             <p className="text-gray-600">
//               Zaloguj się, aby zarządzać treścią strony
//             </p>
//           </div>

//           <form onSubmit={handleSubmit} className="space-y-6">
//             {error && (
//               <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
//                 {error}
//               </div>
//             )}

//             <div>
//               <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
//                 Nazwa użytkownika
//               </label>
//               <input
//                 id="username"
//                 name="username"
//                 type="text"
//                 required
//                 value={credentials.username}
//                 onChange={handleInputChange}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors duration-300"
//                 placeholder="Wprowadź nazwę użytkownika"
//                 disabled={isLoading}
//               />
//             </div>

//             <div>
//               <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
//                 Hasło
//               </label>
//               <input
//                 id="password"
//                 name="password"
//                 type="password"
//                 required
//                 value={credentials.password}
//                 onChange={handleInputChange}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors duration-300"
//                 placeholder="Wprowadź hasło"
//                 disabled={isLoading}
//               />
//             </div>

//             <div>
//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {isLoading ? (
//                   <>
//                     <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Logowanie...
//                   </>
//                 ) : (
//                   'Zaloguj się'
//                 )}
//               </button>
//             </div>
//           </form>

//           <div className="mt-8 text-center">
//             <p className="text-sm text-gray-600">
           
//             </p>
//           </div>
//         </div>

//         <div className="bg-gray-50 px-8 py-6 border-t border-gray-200">
//           <p className="text-xs text-center text-gray-500">
//             © {new Date().getFullYear()} Kolorowe Domki. Wszelkie prawa zastrzeżone.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLoginPanel;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLoginPanel = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    // Czyść błąd przy zmianie danych
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError('');

  try {
    console.log('🟡 Wysyłam dane logowania:', credentials);
    console.log('🟡 URL:', '/api/auth/login.php');
    const response = await fetch('/api/auth/login.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials)
    });
    console.log('🔵 Status odpowiedzi:', response.status);
    console.log('🔵 OK?', response.ok);
    const data = await response.json();
    console.log('🟣 Odpowiedź z serwera:', data);
    if (response.ok) {
      // Zapisanie tokena do localStorage
            console.log('✅ Logowanie udane!');
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminAuthenticated', 'true');
      
      // ✅ POPRAWIONE: Przekierowanie na AdminMenuPanel
      navigate('/admin/AdminMenuPanel');
    } else {
            console.log('❌ Logowanie nieudane:', data.message);
      setError(data.message || 'Nieprawidłowa nazwa użytkownika lub hasło');
    }
  } catch (err) {
    console.error('🔴 Błąd fetch:', err);
    setError('Błąd połączenia z serwerem. Sprawdź czy backend jest skonfigurowany.');
  } finally {
    setIsLoading(false);
  }
};
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError('');

//     try {
//       const response = await fetch('/api/auth/login.php', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(credentials)
//       });

//       const data = await response.json();

//       if (response.ok) {
//         // Zapisanie tokena do localStorage
//         localStorage.setItem('adminToken', data.token);
//         localStorage.setItem('adminAuthenticated', 'true');
//         navigate('/admin/AdminPanelWithStyles');
//       } else {
//         setError(data.message || 'Nieprawidłowa nazwa użytkownika lub hasło');
//       }
//     } catch (err) {
//       setError('Błąd połączenia z serwerem. Sprawdź czy backend jest skonfigurowany.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

  return (
    <div className="min-h-screen bg-[#edece8] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="px-8 py-10">
          <div className="text-center mb-8">
            <img 
              src="images/LOGOModern.jpg" 
              alt="Kolorowe Domki" 
              className="h-24 w-auto mx-auto mb-6"
            />
            <h2 className="text-3xl font-bold text-gray-800 mb-2">
              Panel Administracyjny
            </h2>
            <p className="text-gray-600">
              Zaloguj się, aby zarządzać treścią strony
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                Nazwa użytkownika
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                value={credentials.username}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors duration-300"
                placeholder="Wprowadź nazwę użytkownika"
                disabled={isLoading}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Hasło
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={credentials.password}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors duration-300"
                placeholder="Wprowadź hasło"
                disabled={isLoading}
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Logowanie...
                  </>
                ) : (
                  'Zaloguj się'
                )}
              </button>
            </div>
          </form>

          <div className="mt-8 text-center">
            <p className="text-sm text-gray-600">
              {/* Dodatkowe informacje możesz dodać tutaj */}
            </p>
          </div>
        </div>

        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200">
          <p className="text-xs text-center text-gray-500">
            © {new Date().getFullYear()} Kolorowe Domki. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPanel;